<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
        <div class="col-md-12 mainheader">
            <h5>Add Images</h5>
        </div>
       
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
        <!-- card -->
        <div class="card">
            <!-- card body -->
            <div class="card-body">
                <!-- top row -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="body">
                            <input type="file" id="dropify-event">
                        </div>
                    </div>
                </div>
                <!--/ top row -->
                <div class="row border h-50 py-2">
                    <div class="col-md-3">
                        <figure class="position-relative">
                            <span class="closeicon position-absolute">X</span>
                            <img src="assets/images/1.jpg" alt="" class="img-fluid w-100">
                        </figure>
                    </div>
                    <div class="col-md-3">
                        <figure class="position-relative">
                            <span class="closeicon position-absolute">X</span>
                            <img src="assets/images/1.jpg" alt="" class="img-fluid w-100">
                        </figure>
                    </div>
                    <div class="col-md-3">
                        <figure class="position-relative">
                            <span class="closeicon position-absolute">X</span>
                            <img src="assets/images/1.jpg" alt="" class="img-fluid w-100">
                        </figure>
                    </div>
                    <div class="col-md-3">
                        <figure class="position-relative">
                            <span class="closeicon position-absolute">X</span>
                            <img src="assets/images/1.jpg" alt="" class="img-fluid w-100">
                        </figure>
                    </div>
                </div>
            </div>
            <!--/ card body -->
        </div>
        <!--/ card -->
    </main>
    <!-- main body -->
</div>